import { Chip, IconButton } from '@mui/material'
import Grid from '@mui/material/Grid2'
import LinearProgress from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import MinusIcon from '../../../../assets/icons/Minus.svg?react'
import PlusIcon from '../../../../assets/icons/Plus.svg?react'
import { CardTitleDescription } from '../../../../components/CardTitleDescription'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useSettingStore } from '../../../../store/storeSetting'
import { theme } from '../../../../theme'

const MAX_DEPTH = 15
const MIN_DEPTH = 1

export const MemoryMessageCountStack = () => {
    const {
        updateRequest,
        requestDetail,
        requestMemoryMessageCount,
        setRequestSettingMemoryMessageCount,
        totalMessageCount,
    } = useRequestsStore((state) => state)
    const { modelDetail } = useSettingStore((state) => state)

    const [messageCount, setMessageCount] = useState(
        requestDetail?.memory_message_count ?? requestMemoryMessageCount,
    )

    const updateMemoryMessageCount = (count: number) => {
        if (requestDetail?.id) {
            updateRequest(
                { threadId: requestDetail?.id },
                {
                    memory_message_count: count,
                },
            )
        } else {
            setRequestSettingMemoryMessageCount(count)
        }
    }

    const handleIncrement = () => {
        setMessageCount((prev) => {
            const value = prev + 1

            updateMemoryMessageCount(value)

            return value
        })
    }

    const handleDecrement = () => {
        setMessageCount((prev) => {
            const value = prev - 1

            updateMemoryMessageCount(value)

            return value
        })
    }

    return (
        <>
            <CardTitleDescription
                size={{ xs: 12, md: 6 }}
                title=" Глубина памяти"
                description={`Чем выше параметр, тем более старые сообщения учитываются для новых
                            ответов. Значение от ${MIN_DEPTH} до ${MAX_DEPTH}.`}
                isBorder={true}>
                <Grid
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        display: 'flex',
                        width: '100%',
                    }}>
                    <Typography variant="body2" sx={{ color: '#181B25', width: '50px' }}>
                        <span id="request_message_count">{messageCount} </span>/{' '}
                        <span id="request_message_count_max">{totalMessageCount ?? 10}</span>
                    </Typography>
                    <LinearProgress
                        sx={{
                            width: '34%',
                            [theme.breakpoints.down('sm')]: {
                                width: `33%`,
                            },
                        }}
                        variant="determinate"
                        value={
                            totalMessageCount > messageCount
                                ? '100'
                                : (totalMessageCount / messageCount) * 100
                        }
                    />
                    <Grid
                        sx={{
                            display: 'flex',
                            gap: '4px',
                            justifyContent: 'center',
                        }}>
                        <IconButton
                            id="request_message_decrement"
                            disabled={
                                requestDetail?.is_archived ||
                                modelDetail?.is_restricted ||
                                messageCount === MIN_DEPTH
                            }
                            onClick={handleDecrement}
                            size="small"
                            sx={{
                                backgroundColor: '#F4F4F6',
                            }}>
                            <MinusIcon />
                        </IconButton>
                        <Chip sx={{ height: '30px', width: '40px' }} label={messageCount} />
                        <IconButton
                            id="request_message_increment"
                            disabled={
                                requestDetail?.is_archived ||
                                modelDetail?.is_restricted ||
                                messageCount === MAX_DEPTH
                            }
                            onClick={handleIncrement}
                            size="small"
                            sx={{
                                backgroundColor: '#F4F4F6',
                            }}>
                            <PlusIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </CardTitleDescription>
        </>
    )
}
